import React, { useEffect } from 'react';
import AOS from 'aos';
import "aos/dist/aos.css";
import './index.css';
import {
  BrowserRouter as Router,
  Routes,
  Route
} from 'react-router-dom';
// All pages
import Home from './pages/Home';
import Contact from './pages/Contact';
import DemoProduct from './pages/DemoProduct';
import Dashboard from './components/Dashboard/Dashboard'
import Marketing from './components/Dashboard/Marketing'
import Login from './components/Dashboard/loginPage'
import { AuthProvider } from './components/Dashboard/UseAuth'
import {useDocTitle} from './components/CustomHook';
import ScrollToTop from './components/ScrollToTop';
import Blog from './components/blog/Blog'

function App() {
  useEffect(() => {
    const aos_init = () => {
      AOS.init({
        once: true,
        duration: 1000,
        easing: 'ease-out-cubic',
      });
    }

    window.addEventListener('load', () => {
      aos_init();
    });
  }, []);

  useDocTitle("Sunarc Power Engineers | Solar Panel Installation Services");

  return (
    <>
    <AuthProvider>
      <Router>
        <ScrollToTop>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/get-demo" element={<DemoProduct />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/loginPage" element={<Login />} />
            <Route path="/marketing" element={<Marketing />} />
          </Routes>
        </ScrollToTop>
      </Router>
      </AuthProvider>
    </>
  );
}


export default App;
